import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';
import { getAuthToken } from '../utils/storage';
import { extractApiError } from '../utils/apiError';
import { applyWarehouseFilter, warehouseParamsSerializer } from '../utils/warehouseParams';

/**
 * Assigned -> Before-Challan analytics API.
 * ADMIN / SUPER_ADMIN only. Tracks the workflow window between supervisor
 * assignment and challan generation.
 * Base: `${API_BASE_URL}/api/v1/assigned-to-challan-analytics`
 */
const assignedToChallanAPI = axios.create({
    baseURL: `${API_BASE_URL}/api/v1/assigned-to-challan-analytics`,
    headers: { 'Content-Type': 'application/json' },
    paramsSerializer: warehouseParamsSerializer,
});

assignedToChallanAPI.interceptors.request.use(
    (config) => {
        const token = getAuthToken();
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return applyWarehouseFilter(config);
    },
    (error) => Promise.reject(error)
);

const assignedToChallanService = {
    /** Live backlog: sub-orders assigned but not yet challaned. date_field = assigned_at */
    async getPending(params = {}, options = {}) {
        try {
            const response = await assignedToChallanAPI.get('/pending', { params, ...options });
            return { success: true, data: response.data };
        } catch (error) {
            if (axios.isCancel(error)) {
                return { success: false, error: 'Request canceled', isCanceled: true };
            }
            return { success: false, error: extractApiError(error) };
        }
    },

    /** Historical duration stats for challaned sub-orders. date_field = challan_date */
    async getDuration(params = {}, options = {}) {
        try {
            const response = await assignedToChallanAPI.get('/duration', { params, ...options });
            return { success: true, data: response.data };
        } catch (error) {
            if (axios.isCancel(error)) {
                return { success: false, error: 'Request canceled', isCanceled: true };
            }
            return { success: false, error: extractApiError(error) };
        }
    },
};

export default assignedToChallanService;
